const state = {
  pathStack: [], // [{from: {}, to: {}},...]
  pathLevel: -1,
  direction: 'forward'
}
const mutations = {
  PUSH_PATH (state, {from, to}) {
    state.pathLevel = state.pathLevel + 1
    state.pathStack.push({from, to})
  },
  POP_PATH (state) {
    if (state.pathLevel >= 0) {
      state.pathStack.splice(state.pathLevel, 1)
      state.pathLevel = state.pathLevel - 1
    }
  },
  UPDATE_DIRECTION (state, direction) {
    state.direction = direction
  }
}

export default {
  state,
  mutations
}
